
export default function ToolsSection() {
    return (
        <>
            <section className="section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                    <div className="grid-container">
                        <div className="item item1">
                            <img src="https://dummyimage.com/800x400/fff/000&text=Positive+Vibes+Only" alt="Positive Vibes Only" />
                        </div>
                        <div className="item item2">
                            <img src="https://dummyimage.com/400x400/fff/000&text=Be+Real+Heart" alt="Be Real Heart" />
                        </div>
                        <div className="item item3">
                            <img src="https://dummyimage.com/400x400/fff/000&text=Reflection+Cat" alt="Reflection Cat" />
                        </div>
                    </div>
                </div>
                </div>
                </div>
            </section>
        </>

    )
}
